import { MapDrawingConfig } from "../canvas-drawing";
import { drawPointerHighlightPoints } from "../point-drawing";
import { drawLine } from "../line-drawing";
import { LineStyle } from "PosterEditor/model/poster-types";
import { Point } from "PosterEditor/model/poster-types";
import {
  splitCoordinatesWithInterupt,
  distanceBetweenPoints,
} from "../coordinate-utils";
import { coordinatesToPoints } from "../coordinate-utils";
import { MapElement } from "../canvas-drawing";
import { Coordinate } from "PosterEditor/hooks/use-coordinates";

const interruptLineStyleDefault: LineStyle = {
  width: 1,
  mainColor: "rgba(64, 64, 64, 0.5)",
  mainPattern: "singleSolid",
  dotDash: false,
};

export const drawRouteLines = ({
  map,
  canvasElement,
  originalMapSize,
  scale,
  project,
  gpsSource,
  pointerLocation,
  pointerInteruptRadius,
  elementToHighlight,
  isRendering,
}: MapDrawingConfig) => {
  const ctx = canvasElement.current.getContext("2d");
  if (!map.current || !ctx) return { elementUnderPointerLocation: undefined };

  // Get the device pixel ratio for high DPI displays

  // Scale the canvas according to the device pixel ratio
  //if (!isRendering) {
  //}
  // Set rounded line joins and end caps
  ctx.lineJoin = "round"; // Rounds the corners where lines join
  ctx.lineCap = "round"; // Rounds the ends of the lines

  const lineStyle = project.lineStyle;
  const lineWidth = lineStyle.width * scale;
  const flankDistance = lineWidth;

  const isLabelHilighted =
    elementToHighlight?.type === "mapLabel" ||
    elementToHighlight?.type === "staticLabel";
  const mainColor = lineStyle.mainColor;
  const flankColor = lineStyle.flankColor;

  ctx.globalAlpha = 0.2; //isLabelHilighted ? 0.2 : 1;

  const drawAllLines = (points: Point[]) => {
    const dot =
      lineStyle.mainPattern === "doubleTranslucent"
        ? lineWidth / 6
        : lineWidth / 6;
    const dash =
      lineStyle.mainPattern === "doubleTranslucent"
        ? lineWidth * 2.3
        : lineWidth * 1.5;

    if (lineStyle.mainPattern === "doubleSolid") {
      drawLine(
        ctx,
        points,
        flankDistance,
        flankColor ?? mainColor,
        lineWidth / 2,
        // lineStyle.dotDash ? dot * 3 : undefined,
        // lineStyle.dotDash ? dash / 2 : undefined
        undefined,
        undefined,
        isLabelHilighted ? 0.2 : 0.8
      ); // Flank line with a positive offset
      drawLine(
        ctx,
        points,
        -flankDistance,
        flankColor ?? mainColor,
        lineWidth / 2,
        // lineStyle.dotDash ? dot * 3 : undefined,
        // lineStyle.dotDash ? dash / 2 : undefined
        undefined,
        undefined,
        isLabelHilighted ? 0.2 : 0.8
      ); // Flank line with a negative offset
    } else if (lineStyle.mainPattern === "doubleTranslucent") {
      drawLine(
        ctx,
        points,
        0,
        flankColor ?? mainColor,
        lineWidth * 2.3,
        lineStyle.dotDash ? dot : undefined,
        lineStyle.dotDash ? dash : undefined,
        isLabelHilighted ? 0.1 : 0.8
      );
    }
    drawLine(
      ctx,
      points,
      0,
      mainColor,
      lineWidth,
      lineStyle.dotDash ? dot : undefined,
      lineStyle.dotDash ? dash : undefined,
      isLabelHilighted ? 0.2 : 1
    );
  };

  const source = gpsSource;
  const coordinates: Coordinate[] =
    source?.displayedCoordinates ?? source?.allCoordinates ?? [];

  if (pointerLocation && pointerInteruptRadius) {
    let elementUnderCursor: MapElement | undefined;

    let segments = splitCoordinatesWithInterupt(
      map,
      originalMapSize,
      {
        width: canvasElement.current?.clientWidth ?? 0, // <- but this is undefined???
        height: canvasElement.current?.clientHeight ?? 0,
      },
      coordinates,
      pointerLocation,
      pointerInteruptRadius
    );

    segments.lineSegments.forEach((segment) => {
      drawAllLines(segment);
    });
    if (map) {
      if (segments.closestPointToCursor?.point) {
        const point = segments.closestPointToCursor.point;
        if (
          distanceBetweenPoints(point, pointerLocation) < pointerInteruptRadius
        ) {
          elementUnderCursor = {
            type: "point",
            rect: {
              x: point.x,
              y: point.y,
              width: 0,
              height: 0,
            },
            pointCoordinate: segments.closestPointToCursor,
          };
        }
      }
    }
    segments.interuptSegments.forEach((segment) => {
      drawPointerHighlightPoints(
        segment,
        ctx,
        segments.closestPointToCursor?.point
      );
      drawLine(
        ctx,
        segment,
        0,
        interruptLineStyleDefault.mainColor,
        interruptLineStyleDefault.width
      );
    });
    return {
      elementUnderPointerLocation: elementUnderCursor,
    };
  } else {
    const points = coordinatesToPoints(map, scale, coordinates);
    drawAllLines(points);
  }
  return { elementUnderPointerLocation: undefined };
};
